import PropTypes from "prop-types";
import styled from "styled-components";

import { Button, Flex, Modal, Typography } from "antd";
import { CloseOutlined } from "@ant-design/icons";

const props = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    centered: PropTypes.bool,
    closable: PropTypes.bool,
    width: PropTypes.number,
    contentStyle: PropTypes.object,
};

const TitleModal = ({ open, onClose, title, children, centered, closable, width, contentStyle }) => {
    return (
        <Wrapper
            open={open}
            onCancel={onClose}
            maskClosable={closable !== undefined ? closable : true}
            closeIcon={null}
            footer={null}
            centered={centered || false}
            width={width || 520}
        >
            <Flex className="title" justify="space-between" align="center">
                <Typography.Title level={5} className="mt-0 mb-0" type="secondary">
                    {title}
                </Typography.Title>
                <Button
                    className="close-modal"
                    type="primary"
                    shape="circle"
                    icon={<CloseOutlined />}
                    size="small"
                    onClick={onClose}
                />
            </Flex>
            <div className="content" style={contentStyle || {}}>
                {children}
            </div>
        </Wrapper>
    );
};

const Wrapper = styled(Modal)`
    .ant-modal-content {
        padding: 0;

        .title {
            padding: 15px 20px;

            border-radius: 6px 6px 0 0;

            background-color: var(--color-orange-primary);
        }

        .content {
            padding: 20px;
        }
    }
`;

TitleModal.propTypes = props;

export default TitleModal;
